import { render, staticRenderFns } from "./ComplaintReasonForm.vue?vue&type=template&id=a44b6dd6&"
import script from "./ComplaintReasonForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports